export enum IncidentSeverity {
  LowImpact = 1,
  MediumImpact = 2,
  HighImpact = 3
}

export const IncidentSeverityLabelKeys: Record<IncidentSeverity, string> = {
  [IncidentSeverity.LowImpact]: 'accidents.severity.minor',
  [IncidentSeverity.MediumImpact]: 'accidents.severity.intermediate',
  [IncidentSeverity.HighImpact]: 'accidents.severity.major'
}

export const IncidentSeverityImpactLabelKeys: Record<IncidentSeverity, string> = {
  [IncidentSeverity.LowImpact]: 'accidents.severity.lowImpact',
  [IncidentSeverity.MediumImpact]: 'accidents.severity.moderateImpact',
  [IncidentSeverity.HighImpact]: 'accidents.severity.highImpact'
}